'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _inputsLocal = require('../inputs.local.css');

var _inputsLocal2 = _interopRequireDefault(_inputsLocal);

var _textareaLocal = require('./textarea.local.css');

var _textareaLocal2 = _interopRequireDefault(_textareaLocal);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Input component for large text entry
 */


var TextareaInput = function (_Component) {
  _inherits(TextareaInput, _Component);

  function TextareaInput() {
    _classCallCheck(this, TextareaInput);

    return _possibleConstructorReturn(this, (TextareaInput.__proto__ || Object.getPrototypeOf(TextareaInput)).apply(this, arguments));
  }

  _createClass(TextareaInput, [{
    key: 'renderLabel',
    value: function renderLabel() {
      if (!this.props.label) {
        return null;
      }

      return _react2.default.createElement(_label2.default, {
        htmlFor: this.props.name,
        text: this.props.label,
        className: _inputsLocal2.default.label
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)([_inputsLocal2.default.wrapper, this.props.wrapperClassname])
      }, this.renderLabel(), _react2.default.createElement('textarea', {
        autoComplete: this.props.autoComplete,
        autoFocus: this.props.autoFocus,
        className: (0, _classnames2.default)([_inputsLocal2.default.input, _textareaLocal2.default.textarea, this.props.className, _inputsLocal2.default['theme--' + this.props.theme], this.props.resize === 'both' && _textareaLocal2.default.resizeBoth, this.props.resize === 'none' && _textareaLocal2.default.resizeNone, this.props.resize === 'horizontal' && _textareaLocal2.default.resizeHorizontal, this.props.resize === 'vertical' && _textareaLocal2.default.resizeVertical]),
        cols: this.props.cols,
        'data-auto': this.props.scope + '_' + this.props.name,
        disabled: this.props.disabled,
        id: this.props.id,
        name: this.props.name,
        maxLength: this.props.maxLength,
        minLength: this.props.minLength,
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        rows: this.props.rows,
        value: this.props.value
      }));
    }
  }]);

  return TextareaInput;
}(_react.Component);

TextareaInput.displayName = 'UITextareaInput';
TextareaInput.defaultProps = {
  autoComplete: null,
  autoFocus: false,
  className: null,
  cols: null,
  disabled: null,
  maxLength: null,
  minLength: null,
  label: null,
  onBlur: null,
  onChange: null,
  onFocus: null,
  placeholder: null,
  readOnly: false,
  rows: 6,
  scope: 'input',
  theme: 'normal',
  value: '',
  resize: 'none',
  wrapperClassname: null
};
TextareaInput.propTypes = {
  /**
   * HTML autocomplete attribute
   */
  autoComplete: _propTypes2.default.string,

  /**
   * HTML autofocus attribute
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * Classname appended to input element
   */
  className: _propTypes2.default.string,

  /**
   * Textarea columns
   */
  cols: _propTypes2.default.number,

  /**
   * Sets disabled state on input
   */
  disabled: _propTypes2.default.bool,

  /**
   * Unique id for the input
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Unique name for the input
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * Form label to be applied above input
   */
  label: _propTypes2.default.string,

  /**
   * HTML maxlength attribute
   */
  maxLength: _propTypes2.default.number,

  /**
   * HTML minlength attribute
   */
  minLength: _propTypes2.default.number,

  /**
   * Function called when input is blurred
   */
  onBlur: _propTypes2.default.func,

  /**
   * Function called when change occurs
   */
  onChange: _propTypes2.default.func,

  /**
   * Function called when input is focused
   */
  onFocus: _propTypes2.default.func,

  /**
   * Default input placeholder
   */
  placeholder: _propTypes2.default.string,

  /**
   * Field cannot be written to
   */
  readOnly: _propTypes2.default.bool,

  /**
   * html resize attribute
   */
  resize: _propTypes2.default.oneOf(['none', 'vertical', 'horizontal', 'both']),

  /**
   * Textarea rows
   */
  rows: _propTypes2.default.number,

  /**
   * Define the context/scope of where this input is used
   */
  scope: _propTypes2.default.string,

  /**
   * Sets the color theme to resemble a normal or classic input
   */
  theme: _propTypes2.default.oneOf(['classic', 'normal']),

  /**
   * Input value
   */
  value: _propTypes2.default.string,

  /**
   * Classname for wrapping div
   */
  wrapperClassname: _propTypes2.default.string
};
exports.default = TextareaInput;